/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = DifferentVehicle
 *
 * 1 = Unaffordable
 *
 * 2 = NotInterested
 *
 * 3 = WentElsewhere
 *
 * 4 = NotAvailable
 *
 * 5 = Condition
 *
 * 6 = PoorCustomerService
 *
 * 7 = Other
 */
export enum CancelReason {
  DifferentVehicle = 0,
  Unaffordable = 1,
  NotInterested = 2,
  WentElsewhere = 3,
  NotAvailable = 4,
  Condition = 5,
  PoorCustomerService = 6,
  Other = 7,
}
